import React from "react";
import "./AboutSection.css";

export default function AboutSection() {
  return (
    <section className="about-section">
      <div className="container">
        <p className="brand-description">
          BearBitz is a delightful biscuit brand crafted to satisfy every
          craving with a wide range of flavors and textures. From classic
          glucose and milk biscuits to rich cream-filled treats, buttery
          cookies, crispy wafers, and crunchy crackers, BearBitz brings joy to
          every bite. Whether you prefer the comforting taste of vanilla, the
          indulgence of chocolate, or the fruity zing of strawberry and mango,
          BearBitz offers something for all ages and tastes. With quality
          ingredients and irresistible flavor, BearBitz makes snack time a
          moment to cherish—anytime, anywhere.
        </p>
      </div>
    </section>
  );
}
